jQuery.fn.redraw = function() {
    this.css('display', 'none');
    var temp = this[0].offsetHeight;
    this.css('display', '');
    temp = this[0].offsetHeight;
};